import React from "react";
import { Card, CardContent, CardHeader, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import {
  EntityHasSystemsCard,
  EntityLayout,
  EntityLinksCard,
  AboutField,
  RelatedEntitiesCard,
} from '@backstage/plugin-catalog';
import { featureFlagsApiRef, useApi } from "@backstage/core-plugin-api";
import { MarkdownContent, Link } from "@backstage/core-components";
import { EaPackGroupEntityV1beta1 } from "@internal/plugin-ea-pack-common";
import { EntitySoundcheckContent } from "@spotify/backstage-plugin-soundcheck";
import { EntityTable, useEntity } from "@backstage/plugin-catalog-react";
import { Entity, GroupEntity, RELATION_HAS_PART, RELATION_PART_OF } from "@backstage/catalog-model";
import ListAltIcon from '@material-ui/icons/ListAlt';
import { EntityGroupProfileCard, EntityMembersListCard, EntityOwnershipCard } from "@backstage/plugin-org";
import { UserAndTitleField } from "../UserCard";

export const ProductTeamEntityLayout = () => {
  const entity = useEntity().entity as EaPackGroupEntityV1beta1;
  const roles = entity.spec.roles;
  const jiraProjectKey = entity.metadata.annotations?.["jira/project-key"]

  return (
    <EntityLayout parentEntityRelations={["partOf"]}>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardHeader
                title="Product Team Leads"
                action={<>
                  <IconButton
                    component={Link}
                    aria-label="Jira"
                    disabled={jiraProjectKey === undefined}
                    title={"Jira Dashboard"}
                    to={`https://pandoradigital.atlassian.net/browse/${encodeURIComponent(jiraProjectKey!)}`}
                  >
                    <ListAltIcon />
                  </IconButton>
                </>
                } />
              <Divider />
              <CardContent >
                <Grid container>
                  <UserAndTitleField user={roles?.teamManager} title="Delivery" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                  <UserAndTitleField user={roles?.productManager} title="Product" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                  <UserAndTitleField user={roles?.leadEngineer} title="Engineering" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                </Grid>
              </CardContent>
            </Card>

          </Grid>
          <Grid item xs={12} md={6}>
            <EntityOwnershipCard />
          </Grid>
          <Grid item xs={12}>
            <EntityMembersListCard memberDisplayTitle="All team members" />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      <EntityLayout.Route path="/soundcheck" title="Soundcheck" if={_ => useApi(featureFlagsApiRef).isActive("soundcheck")}>
        <EntitySoundcheckContent />
      </EntityLayout.Route>
    </EntityLayout>
  );
};